import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus, Loader2 } from 'lucide-react';
import api from '@/lib/api';

interface CustomsInvoice {
  id: string;
  etax_status: string;
  destination_country: string;
  origin_country: string | null;
  total_estimated_duty: number | null;
  uploaded_at: string;
  completed_at: string | null;
}

export default function AdminCustomsInvoices() {
  const [items, setItems] = useState<CustomsInvoice[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api
      .get<{ invoices: CustomsInvoice[] }>('/admin/customs/invoices')
      .then((d) => setItems(d.invoices))
      .catch((e) => setError(e instanceof Error ? e.message : String(e)));
  }, []);

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-xl font-semibold">Customs Invoices</h1>
        <Link
          to="/admin/customs/new"
          className="inline-flex items-center px-3 py-2 rounded bg-blue-600 text-white text-sm"
        >
          <Plus className="w-4 h-4 mr-1" /> New invoice
        </Link>
      </div>
      {error && <div className="p-3 bg-red-50 text-red-800 rounded mb-4">{error}</div>}
      {items === null && !error && <Loader2 className="w-5 h-5 animate-spin text-gray-400" />}
      {items && items.length === 0 && (
        <div className="p-8 text-center text-gray-500 border rounded">
          No customs invoices yet.
        </div>
      )}
      {items && items.length > 0 && (
        <table className="w-full text-sm">
          <thead className="text-left border-b">
            <tr className="text-gray-600">
              <th className="py-2">ID</th>
              <th>Status</th>
              <th>Destination</th>
              <th>Origin</th>
              <th className="text-right">Est. duty</th>
              <th>Uploaded</th>
            </tr>
          </thead>
          <tbody>
            {items.map((it) => (
              <tr key={it.id} className="border-b hover:bg-gray-50">
                <td className="py-2">
                  <Link to={`/admin/customs/${it.id}`} className="text-blue-700 font-mono">
                    {it.id.slice(0, 8)}
                  </Link>
                </td>
                <td className="capitalize">{it.etax_status}</td>
                <td>{it.destination_country}</td>
                <td>{it.origin_country || '—'}</td>
                <td className="text-right">
                  {it.total_estimated_duty != null
                    ? `$${Number(it.total_estimated_duty).toFixed(2)}`
                    : '—'}
                </td>
                <td className="text-gray-500">{new Date(it.uploaded_at).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
